import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import QuizApp from "./quizApp";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { clarity } from "clarity-js";

posthog.init(process.env.POSTHOG_API_TOKEN, {
  api_host: "https://app.posthog.com",
  persistence: "localStorage+cookie",
});

clarity.start({
  projectId: process.env.CLARITY_PROJECT_ID,
});

Sentry.init({
  dsn: "https://a8282f851c8f435093675f07d4ae14a8@o402889.ingest.sentry.io/5836346",
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ["www.gainful.com", "staging.gainful.com"],
    }),
    new posthog.SentryIntegration(posthog, "gainful-xc", 5836346),
  ],
  environment: process.env.ENVIRONMENT,
  release: process.env.RELEASE_TAG,
  enabled: process.env.DISABLE_SENTRY_LOGGING == "0",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.25,
  sampleRate: 0.25,
  enableTracing: true,
});

const root = createRoot(document.getElementById("root"));

root.render(
  <PostHogProvider client={posthog}>
    <QuizApp />
  </PostHogProvider>
);
